export default __webpack_public_path__ + "static/media/404.e7c38c2a.png";